const routes = [
  { path: "/session/client/:id", labelGroup: "Interaction.Client" },
  { path: "/session/moderator/:id", labelGroup: "Interaction.Moderator" },
  { path: "/presenter/:id", labelGroup: "Interaction.Presenter" },
  { path: "/session/stage/:id", labelGroup: "Interaction.Stage" },
  { path: "/digitalarena/:id", labelGroup: "Interaction.Client" },
  { path: "/exhibitor/:id", labelGroup: "Exhibitor.Moderator" },
  { path: "/exhibitor2/:id", labelGroup: "Exhibitor.Moderator" },
  { path: "/booth/:id", labelGroup: "Exhibitor.Client" },
  { path: "/session/chatmoderator/:id", labelGroup: "Interaction.ChatModerator" },
  { path: "/editor/:id", labelGroup: "Interaction.Editor" },
  { path: "/backstage/:id", labelGroup: "Interaction.Backstage" },
  { path: "/channels/:id", labelGroup: "Interaction.ChannelList" },
];
export default routes;
